import React from "react";
import Preview from "./Preview";
import './Homepage.css';
import dsClose from "./photos/geo-pyramid/ds-close.webp";
import ledOn from "./photos/electronic-prod/led-on.webp";
import finalFootprint from "./photos/breakout-design/final-footprint.webp";
import print_2_support from "./photos/3dp/print_2_support.webp";
import multi_site from './photos/electronic-programming/multi_site.webp';
import snakeHead from "./photos/laser-snake/snakeHead.webp";
import linebotAngle from './photos/fp-cad/linebotAngle.webp';
import fullShelf from "./photos/cordshelf/full.webp";
import tofAssembly from "./photos/tof-test/sensor.webp";
import finalCart from "./photos/motor-test/finalCart.webp";
import networkCart from "./photos/networking/cart.webp";
import finalinterface from "./photos/interface/finalinterface.webp";
import fullyPopulated from "./photos/xiao/fullyPopulated.webp";

const PreviewManager = (props) => {
    return (
        <div className="HP-previewContainer">
            <Preview img={fullyPopulated} caption="Week 14: How to Make a XIAO" action={() => props.changePage('week14')} />
            <Preview img={null} caption="Week 13: Machine Week" action={() => props.changePage('week13')} />
            <Preview img={finalinterface} caption="Week 12: Interface and Application Programming" action={() => props.changePage('week12')} />
            <Preview img={networkCart} caption="Week 11: Networking" action={() => props.changePage('week11')} />
            <Preview img={finalCart} caption="Week 10: Output Devices" action={() => props.changePage('week10')} />
            <Preview img={tofAssembly} caption="Week 9: Input Devices" action={() => props.changePage('week9')} />
            <Preview img={fullShelf} caption="Week 8: Large Format Machining" action={() => props.changePage('week8')} />
            <Preview img={dsClose} caption="Week 7: Molding and Casting" action={() => props.changePage('week7')} />
            <Preview img={ledOn} caption="Week 6: Electronic Production" action={() => props.changePage('week6')} />
            <Preview img={finalFootprint} caption="Week 5: Embedded Design" action={() => props.changePage('week5')} />
            <Preview img={print_2_support} caption="Week 4: 3D Scanning and Printing" action={() => props.changePage('week4')} />
            <Preview img={multi_site} caption="Week 3: Embedded Programming" action={() => props.changePage('week3')} />
            <Preview img={snakeHead} caption="Week 2: Vinyl and Laser Cutting" action={() => props.changePage('week2')} />
            <Preview img={linebotAngle} caption="Week 1: 3D CAD" action={() => props.changePage('week1')} />
        </div>
    )
}

export default PreviewManager;